if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

    hide() {
        super.hide();
        // Esperamos un pequeño tiempo para asegurar que el modal ha terminado de cerrarse
        setTimeout(() => {
          window.location.reload();
        }, 100); // Puedes ajustar el tiempo si es necesario
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

showActiveMedia() {
  // En lugar de ocultar todas menos la clicada,
  // añadimos 'active' a todas las imágenes para que se vean
  this.querySelectorAll('[data-media-id]').forEach((element) => {
    element.classList.add('active');
  });

  // Ya no hacemos scroll horizontal ni centramos ninguna imagen
  // Puedes quitar o comentar las siguientes líneas:

  /*
  const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
  activeMedia.scrollIntoView();

  const container = this.querySelector('[role="document"]');
  container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

  if (
    activeMedia.nodeName == 'DEFERRED-MEDIA' &&
    activeMediaContent &&
    activeMediaContent.querySelector('.js-youtube')
  )
    activeMedia.loadContent();
  */
}
    }
  );
}
